import { cn } from '@/lib/utils';

export function ComingSoonTag({ className }: Readonly<{ className?: string }>) {
  return (
    <span
      aria-label="Coming soon"
      className={cn(
        'ml-1 inline-flex items-center rounded-sm bg-muted px-1.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground',
        className,
      )}
    >
      coming soon
    </span>
  );
}
